// src/components/Advantages.js (added background image)
import React from 'react';
import { FaClock, FaCode, FaSmile, FaRocket, FaChartLine } from 'react-icons/fa';

const advantages = [
  { icon: <FaClock />, text: 'Instant Workflow Adjustments' },
  { icon: <FaCode />, text: 'Reduced Developer Dependency' },
  { icon: <FaSmile />, text: 'Enhanced Customer Experience' },
  { icon: <FaRocket />, text: 'Scalability & Cost Efficiency' },
  { icon: <FaChartLine />, text: 'Improved Operational Agility' }
];

const Advantages = () => {
  return (
    <section id="advantages" className="py-16 bg-gray-100 bg-cover bg-center" 
      style={{backgroundImage: 'url(https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80)'}}>
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-white bg-blue-600 bg-opacity-75 py-2 rounded">Business Advantages</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {advantages.map((advantage, index) => (
            <div key={index} className="flex items-center space-x-4 p-4 bg-white bg-opacity-90 rounded-lg">
              <div className="text-blue-600 text-2xl">{advantage.icon}</div>
              <p className="text-lg font-medium">{advantage.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;